﻿import { apiGet, apiPost } from "./apiClient";
import { getCurrentUserCreatedAt } from "./userRights";
import stepsConsts from "../constants/shepherdConstants";

function GetSteps() {
    return new Promise((resolve) => {
        var stepsForShow = [];

        var isViewedStep = function (stepName, viewedSteps) {
            for (var i = 0; i < viewedSteps.length; i++) {
                if (viewedSteps[i] === stepName) {
                    return true;
                }
            }
            return false;
        };

        var markAsShow = function(stepName) {
            apiPost('Shepherd/SaveStep', { step: stepName });
        }

        var userCreatedAtString = getCurrentUserCreatedAt();
        if (!userCreatedAtString) {
            resolve([]);
        }

        var userCreatedAt = new Date(userCreatedAtString);
        apiGet('Shepherd/GetSteps').then(data => {
            var viewedSteps = data.steps;
            for (var i = 0; i < stepsConsts.length; i++) {
                var constStep = stepsConsts[i];
                if (isViewedStep(constStep.step, viewedSteps))
                    continue;

                if (constStep.date < userCreatedAt) {
                    continue;
                }

                var step = {
                    title: constStep.step,
                    buttons: [
                        {
                            type: 'next',
                            text: 'Продолжить'
                        }
                    ],
                    when: {
                        show: function() {
                            var currentStep = this;
                            markAsShow(currentStep.options.title);
                        },
                        hide: function() {
                            var currentStep = this;
                            currentStep.destroy();
                        }
                    }
                };
                var stepText = null;
                if (constStep.file) {
                    if (constStep.file.format === 'PDF') {
                        stepText = '<object width="100%" height="100%" type="application/pdf" data="' + constStep.file.path + '"></object>';
                    } else if (constStep.file.format === 'HTML') {
                        stepText = '<iframe width="100%" height="100%" src="' + constStep.file.path + '"></iframe>';
                    } else {
                        stepText = '<a href="' + constStep.file.path + '">Скачать</a>';
                    }
                } else {
                    stepText = constStep.text;
                }
                step.text = stepText;

                stepsForShow.push(step);
            }

            resolve(stepsForShow);
        });
    });
}

export default GetSteps;


//////////////////
// WEBPACK FOOTER
// ./App/services/shepherdService.js
// module id = 1133
// module chunks = 0